
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cartao",
      function () {
        return require("private-next-pages/cartao/index.js");
      }
    ]);
  